var element = document.querySelector('.truncatable');

// Check if content is actually overflowing to show/hide "Read More"
if (element && (element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth)) {
  element.classList.add('truncated');
}

document.querySelectorAll('.expand').forEach((truncatedOpener) => {
  truncatedOpener.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const parent = truncatedOpener.parentNode;
    // 1. Calculate the full height of the text inside
    const fullHeight = parent.scrollHeight;
    
    // 2. Set the max-height inline so the CSS transition has a target
    parent.style.maxHeight = (fullHeight + 40) + 'px';
    parent.classList.add('expanded');
  });
});

document.querySelectorAll('.shrink').forEach((truncatedCloser) => {
  truncatedCloser.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const parent = truncatedCloser.parentNode;
    // 3. Remove the inline height to let it collapse back to the CSS default
    parent.style.maxHeight = '';
    parent.classList.remove('expanded');
  });
});